export function mapResponseToDefaults(template, response) {
    if (typeof template !== 'object' || Array.isArray(response) || template === null) {
        return response ?? template;
    }

    const result = Array.isArray(template) ? [] : {};

    for (const key in template) {
        const templateValue = template[key];
        const responseValue = response?.[key];

        result[key] = mapResponseToDefaults(templateValue, responseValue);
    }

    return result;
}
